<template>
  <div class="wrapper mt-3">
    <template v-if="userType === 'adviser'">
      <adviser-settings v-if="hasValidAccount" />
      <f-alert
        v-else
        visible
        class="my-5"
        theme="inactive">
        <span>
        {{ $t('settlements.sectionAvailableForActiveUsers') }}
        </span>
      </f-alert>
    </template>
    <template v-else-if="userType === 'customer'">
      <customer-settings />
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import CustomerSettingsWrapper from '@/views/forms/settings/CustomerSettingsWrapper.vue';
import AdviserSettings from '@/views/forms/settings/AdviserSettings.vue';

export default {
  name: 'settings',
  components: {
    'adviser-settings': AdviserSettings,
    'customer-settings': CustomerSettingsWrapper
  },
  data() {
    return {
      hasValidAccount: null,
      userType: null
    };
  },
  mounted () {
    Vue.set(this, 'hasValidAccount', this.$store.getters['getUserHasValidAccount']);
    this.userType = this.$store.getters['getUserType'].toLowerCase();
  }
};
</script>
